<div class="drive-view" [class.sidebar-collapsed]="sidebarCollapsed">
  <div class="drive-sidebar-panel" [class.collapsed]="sidebarCollapsed">
    <button
      nz-button
      nzType="text"
      class="drive-sidebar-toggle"
      [title]="sidebarCollapsed ? '展开目录' : '收起目录'"
      (click)="toggleSidebar()"
    >
      <span nz-icon [nzType]="sidebarCollapsed ? 'menu-unfold' : 'menu-fold'"></span>
    </button>
    <app-resource-drive-sidebar
      *ngIf="!sidebarCollapsed"
      [treeNodes]="treeNodes"
      [expandedKeys]="expandedKeys"
      [selectedKeys]="selectedKeys"
      [sidebarError]="sidebarError"
      [loading]="sidebarLoading"
      (folderSelect)="folderSelect.emit($event)"
      (expandedKeysChange)="expandedKeysChange.emit($event)"
      (retryCategory)="retryCategory.emit()"
    ></app-resource-drive-sidebar>
  </div>

  <app-resource-drive-content
    [state]="contentState"
    [searchKeyword]="searchKeyword"
    [isDriveSearch]="isDriveSearch"
    [folderCards]="folderCards"
    [fileCards]="fileCards"
    [sortableFileCards]="sortableFileCards"
    [otherFileCards]="otherFileCards"
    [canSortFiles]="canSortFiles"
    [breadcrumb]="breadcrumb"
    [filesLoadError]="filesLoadError"
    [totalNum]="totalNum"
    [pageIndex]="pageIndex"
    [pageSize]="pageSize"
    [resourceType]="resourceType"
    [showCopyAction]="showCopyAction"
    [currentFolderId]="currentFolderId"
    [selectionResetToken]="selectionResetToken"
    [hasClipboard]="hasClipboard"
    [canPaste]="canPaste"
    (pageChange)="pageChange.emit($event)"
    (fileOpen)="fileOpen.emit($event)"
    (fileAction)="fileAction.emit($event)"
    (folderOpen)="folderOpen.emit($event)"
    (folderAction)="folderAction.emit($event)"
    (folderSort)="folderSort.emit($event)"
    (fileSort)="fileSort.emit($event)"
    (breadcrumbNavigate)="breadcrumbNavigate.emit($event)"
    (retryFiles)="retryFiles.emit()"
    (selectionToolbarAction)="selectionToolbarAction.emit($event)"
  ></app-resource-drive-content>
</div>
